import { useState } from "react";
import { IconButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { ChatAppResponse } from "../../api";
import { SpeechOutputAzure } from "./SpeechOutputAzure";
import { SpeechOutputBrowser } from "./SpeechOutputBrowser";

interface AnswerActionsProps {
    answer: ChatAppResponse;
    index: number;
    sessionId?: string;
    speechConfig: any;
    isStreaming: boolean;
    onThoughtProcessClicked: () => void;
    onSupportingContentClicked: () => void;
    showSpeechOutputAzure?: boolean;
    showSpeechOutputBrowser?: boolean;
    sanitizedAnswerHtml: string;
}

export const AnswerActions = ({
    answer,
    index,
    sessionId,
    speechConfig,
    isStreaming,
    onThoughtProcessClicked,
    onSupportingContentClicked,
    showSpeechOutputAzure,
    showSpeechOutputBrowser,
    sanitizedAnswerHtml,
}: AnswerActionsProps) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(sanitizedAnswerHtml);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    return (
        <div>
            <IconButton
                style={{ color: copied ? "green" : "black" }}
                iconProps={{ iconName: copied ? "CheckMark" : "Copy" }}
                title={t("tooltips.copyAnswer")}
                ariaLabel={t("tooltips.copyAnswer")}
                onClick={handleCopy}
                disabled={isStreaming}
            />
            <IconButton
                style={{ color: "black" }}
                iconProps={{ iconName: "Lightbulb" }}
                title={t("tooltips.showThoughtProcess")}
                ariaLabel={t("tooltips.showThoughtProcess")}
                onClick={() => onThoughtProcessClicked()}
                disabled={!answer.context.thoughts?.length}
            />
            <IconButton
                style={{ color: "black" }}
                iconProps={{ iconName: "ClipboardList" }}
                title={t("tooltips.showSupportingContent")}
                ariaLabel={t("tooltips.showSupportingContent")}
                onClick={() => onSupportingContentClicked()}
                disabled={!answer.context.data_points}
            />
            {showSpeechOutputAzure && (
                <SpeechOutputAzure
                    answer={sanitizedAnswerHtml}
                    index={index}
                    speechConfig={speechConfig}
                    isStreaming={isStreaming}
                />
            )}
            {showSpeechOutputBrowser && (
                <SpeechOutputBrowser answer={sanitizedAnswerHtml} index={index} sessionId={sessionId} />
            )}
        </div>
    );
}; 